import { HttpAdapter } from "../../main/adapters/HttpAdapter";
import { MissingParamError } from "../../utils/erros/erros";

export class AccountingCampaign {
    HttpAdapter = new HttpAdapter();
    // Rota única do radar: a ação vai no corpo (`acao`), não no caminho.
    baseUrl = `${publicSettings.aws.baseUrls.radar}/radar/campanhas`;

    async getActive(accountingId) {
        if (!accountingId) throw new MissingParamError("accountingId");
        return await this.HttpAdapter.call(this.baseUrl, {
            acao: "ativa",
            accountingId
        });
    }

    async registerInteraction(accountingId, campaignId, interaction) {
        if (!accountingId) throw new MissingParamError("accountingId");
        if (!campaignId) throw new MissingParamError("campaignId");
        if (!interaction) throw new MissingParamError("interaction");
        return await this.HttpAdapter.call(this.baseUrl, {
            acao: "interacao",
            accountingId,
            campaignId,
            interaction
        });
    }
}
